import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { waLink } from "../data/site";

const LINKS = [
  { href: "#como-funciona", label: "Como funciona" },
  { href: "#simular", label: "Simulador" },
  { href: "#depoimentos", label: "Depoimentos" },
  { href: "#clube", label: "iGreen Club" },
  { href: "#servicos", label: "Serviços" },
  { href: "#faq", label: "Dúvidas" },
];

export const Navbar = ({ basePath = "" }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#04120E]/85 border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={`${basePath}${l.href}`}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm font-medium text-emerald-100/70 hover:text-[#00E676] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-cta"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#00E676] hover:bg-[#00C853] text-[#04120E] text-sm font-bold px-5 py-2.5 shadow-[0_0_20px_rgba(0,230,118,0.4)] transition-[background-color,transform] duration-300 hover:scale-[1.03]"
          >
            Falar no WhatsApp
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 rounded-lg border border-white/15 text-white"
            aria-label="Abrir menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden backdrop-blur-xl bg-[#04120E]/95 border-t border-white/10 px-6 py-5 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={`${basePath}${l.href}`}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-emerald-100/80 hover:text-[#00E676] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-mobile-whatsapp-cta"
            className="mt-2 inline-flex justify-center rounded-full bg-[#00E676] text-[#04120E] font-bold px-5 py-3"
          >
            Falar no WhatsApp
          </a>
        </nav>
      )}
    </header>
  );
};
